import ES from './es';
import EN from './en';

const dashboards = {
    ES,
    EN
};

export default dashboards;
